module.exports = __webpack_public_path__ + "img/login-arrow.f3307a59.png";